import { useEffect } from 'react';
import { Form, FormItem, Input, Password, Title, Row, Col, Layout, Button } from '@/components/atoms';
import { pcompany } from '@/proto/proto';

type ServiceAccountItemProps = {
  data?: pcompany.IPbCompanyExternal;
  onClickSave?: (id?: string, password?: string) => void;
};

const ServiceAccountItem = ({ data, onClickSave }: ServiceAccountItemProps) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      userId: data?.userId,
      userPassword: data?.userPassword,
    });
  }, [data, form]);

  return (
    <Layout className="account-item">
      <Row justify="space-between">
        <Col>
          <Title>{data?.typeName}</Title>
        </Col>
        <Col>
          <Button
            shape="round"
            onClick={() => {
              if (onClickSave) {
                onClickSave(form.getFieldValue('userId'), form.getFieldValue('userPassword'));
              }
            }}
          >
            저장
          </Button>
        </Col>
      </Row>
      <Form layout="vertical" form={form}>
        <Row>
          <Col>
            <FormItem label="아이디" name="userId">
              <Input placeholder="아이디" />
            </FormItem>
          </Col>
          <Col>
            <FormItem label="비밀번호" name="userPassword">
              <Password placeholder="비밀번호" />
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Layout>
  );
};

ServiceAccountItem.defaultProps = {
  data: undefined,
  onClickSave: undefined,
};

export default ServiceAccountItem;
